module.exports = __webpack_public_path__ + "media/images/svg/jumping-cardio-7026903bd474ebecdb61a99942796509.svg";